import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import CompanyStory from '../components/CompanyStory';

function AboutPage() {
  return (
    <>
      <PageHero
        label="Nexus Concordat"
        title="About"
        subtitle="Built from the biochemistry of humanity. Not from static benchmarks."
      />
      <BackButton />
      <CompanyStory />
    </>
  );
}

export default AboutPage;
